import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <path d="M32,10H7.52l5.36-5.8a2.26,2.26,0,0,0,.61-1.62A2.24,2.24,0,0,0,9.6,1.17L.87,10.52A2.21,2.21,0,0,0,0,12.28c0,.11,0,.23,0,.34a2.23,2.23,0,0,0,.58,1.23l9,9.65a2.3,2.3,0,0,0,1.64.72,2.28,2.28,0,0,0,2.06-1.36,2.25,2.25,0,0,0-.42-2.42L7.43,14.53H32a13,13,0,0,1,13,13v1a13,13,0,0,1-13,13H2.25a2.25,2.25,0,0,0,0,4.5H32A17.51,17.51,0,0,0,49.46,28.51v-1A17.51,17.51,0,0,0,32,10Z" />
  </svg>
);
